<template>
  <transition name="about" appear @enter="enter" @leave="leave">
    <div>
      <div class="transition-block white"></div>
      <div class="transition-block black"></div>
      <main>
        <div class="about-container">
          <div class="bonjour">
            <h4>Bonjour.</h4>
          </div>
          <div class="about-content" ref="aboutContent">
            <p>
              Je suis Davy Jacquemard, un étudiant avec un grand intêret pour la mode, le design et les interactions. Pour moi, chaque détail compte. Je suis actuellement développeur front-end chez
              <a
                href="http://adeliom.com/"
              >Adeliom Agency</a> à Strasbourg dans le cadre de mon stage.
              <br />
              <br />Un projet, une idée, une suggestion ? N'hésitez pas à me laisser un mot !
            </p>
            <div class="email-container">
              <div class="email-title">
                email
                <img
                  class="external-arrow"
                  src="../../static/images/icones/diagonal-arrow-white.png"
                  alt="Icone"
                />
              </div>
              <div class="email-content">
                <a href="mailto:hello@davyjacquemard.com">hello[at]davyjacquemard.com</a>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </transition>
</template>

<script>
export default {
  name: "About",
  data() {
    return {};
  },
  methods: {
    enter(el, done) {
      var blockWhite = el.querySelector(".transition-block.white");
      var blockBlack = el.querySelector(".transition-block.black");
      var main = el.querySelector("main");
      var bonjour = el.querySelector(".bonjour h4");
      var content = this.$refs.aboutContent;

      TweenMax.to(blockWhite, 0.8, {
        delay: 0.2,
        height: "100vh",
        ease: Power4.easeOut
      });
      TweenMax.to(blockWhite, {
        delay: 1,
        "z-index": 1,
        ease: Power4.easeOut
      });

      TweenMax.set(main, {
        autoAlpha: 0
      });
      TweenMax.to(main, {
        delay: 0.8,
        autoAlpha: 1,
        ease: Power4.easeOut
      });

      TweenMax.set(bonjour, {
        y: "100%"
      });
      TweenMax.to(bonjour, 1, {
        delay: 1,
        y: "0",
        ease: Power4.easeOut,
        
      });

      TweenMax.set(content, {
        opacity: 0,
        y: '100px',
      });
      TweenMax.to(content, 1, {
        delay: 1.4,
        opacity: 1,
        y: "0",
        ease: Power4.easeOut,
        onComplete: done
      });
    },
    leave(el, done) {
      var blockWhite = el.querySelector(".transition-block.white");
      var blockBlack = el.querySelector(".transition-block.black");
      TweenMax.set(blockBlack, {
        height: "100vh"
      });
      TweenMax.to(blockBlack, 0.8, {
        delay: 0.2,
        y: "-100vh",
        ease: Power4.easeOut,
        onComplete: done
      });
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
$break-medium: 768px;
$break-large: 1260px;

.transition-block {
  width: 100vw;
  height: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: #ea5242;
  &.black {
    background-color: #0e0d10;
    z-index: 100;
    top: 100vh;
  }
}
main {
  background-color: #ea5242;
  padding-top: 62px;
    padding-bottom: 80px;
  p {
    font-size: 1.8rem;
    line-height: 2.7rem;
    @media screen and (min-width: $break-medium) {
      font-size: 2.2rem;
      line-height: 3.3rem;
    }
  }
  .about-container {
    position: relative;
    z-index: 2;
    width: 85%;
    max-width: 960px;
    margin: auto;
    height: 100vh;
    @media screen and (min-width: $break-medium) {
       width: 80%;
    }
    @media screen and (min-width: $break-large) {
       width: 70%;
    }
    .bonjour {
      margin-top: 30vh;
      margin-bottom: 20vh;
      overflow: hidden;
      h4 {
         font-family: bely-display, sans-serif;
        font-size: 11vw;
        color: white;
        letter-spacing: 0;
        margin: 0;
      }
    }
    .email-container {
      margin-top: 150px;
      text-transform: uppercase;
      font-family: "Uni Sans", sans-serif;
      text-align: center;

      .email-title {
        margin-bottom: 40px;
        img {
          transform: rotate(90deg);
          height: 1.4rem;
        }
      }
      .email-content {
        font-size: 4vw;
        font-weight: 900;

        @media screen and (min-width: $break-medium) {
          font-size: 3vw;
          -webkit-text-fill-color: rgba($color: #fff, $alpha: 0);
          -webkit-background-clip: text;
          -webkit-text-stroke-width: 1px;
          -webkit-text-stroke-color: white;
          background-color: white;
          background-size: 200% 100%;
          background-position: 100%;
          transition: all 0.5s ease-out;
        }
        @media screen and (min-width: $break-large) {
          font-size: 2.5vw;
        }
        &:hover {
          background-color: transparent;
          transition: all 0.5s ease-out;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/About.vue